export class ArrayUtils {
  private constructor() {}
  public static createArrayWithLength<T>(length: number, createItem: (index: number) => T): Array<T> {
    const array: Array<T> = [];
    for (let i = 0; i < length; i++) {
      array.push(createItem(i));
    }
    return array;
  }
  public static areShallowEqual<T>(a: Readonly<Array<T>>, b: Readonly<Array<T>>): boolean {
    if (a.length !== b.length) {
      return false;
    }
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
    return true;
  }
  public static group<TItem, TKey>(items: Array<TItem>, getKey: (item: TItem) => TKey): Map<TKey, Array<TItem>> {
    const groupedItems = new Map<TKey, Array<TItem>>();
    for (const item of items) {
      let itemsInGroup = groupedItems.get(getKey(item));
      if (!itemsInGroup) {
        itemsInGroup = [];
        groupedItems.set(getKey(item), itemsInGroup);
      }
      itemsInGroup.push(item);
    }
    return groupedItems;
  }
  public static key<TItem, TKey>(items: Array<TItem>, getKey: (item: TItem) => TKey): Map<TKey, TItem> {
    const keyedItems = new Map<TKey, TItem>();
    for (const item of items) {
      keyedItems.set(getKey(item), item);
    }
    return keyedItems;
  }

  /**
   * Sum up all numbers in the given array.
   *
   * @example
   * assert(ArrayUtils.sum([1, 2, 3, 4]) === 10);
   */
  public static sum(arr: Array<number>): number {
    return arr.reduce((a, b) => a + b, 0);
  }

  /**
   * If the item is not included in the items, this function will return a shallow copy of the items including the item.
   * If the item is already included in the items, this function will return a shallow copy of the items.
   */
  public static pushUnique<TItem>(items: Array<TItem>, item: TItem): Array<TItem> {
    const returnValue = items.slice();
    if (!returnValue.includes(item)) {
      returnValue.push(item);
    }
    return returnValue;
  }
}